import { Route } from '@/router/types'
// Imports used multiple times in the router are below.
// Otherwise, they should be imported inline in the router.
const TabbedPatientProfile = () =>
  import('@/legacy/pages/PatientProfileTabbed/PatientProfileTabbed.vue')

const patientProfileTabbed: Route[] = [
  {
    path: '/patient/:patientId/care-plan',
    name: '#patientProfileCarePlan',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Care Plan',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/clinical-summary',
    name: '#patientProfileClinicalSummary',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Clinical Summary',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/social-summary',
    name: '#patientProfileSocialSummary',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Social Summary',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/history',
    name: '#patientProfileHistory',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - History',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/to-do',
    name: '#patientProfileToDo',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - To Do',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/symptoms',
    name: '#patientProfileSymptoms',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Symptoms',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/texting',
    name: '#patientProfileTexting',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Texting',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/medical-context',
    name: '#patientProfileMedicalContext',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Medical Context',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/documents',
    name: '#patientProfileDocuments',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile - Documents',
      permissionCheck: null,
    },
  },
]

export const patientRoutes: Route[] = [
  {
    path: '/patient/:patientId/',
    name: '#patientProfile',
    component: TabbedPatientProfile,
    meta: {
      title: 'Patient Profile',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/audit-log',
    name: '#patientAuditLog',
    component: () => import('@/pages/AuditLog/AuditLog.vue'),
    meta: {
      title: 'Patient Audit Log',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/report/comprehensive',
    name: '#patientComprehensiveReport',
    component: () =>
      import('@/pages/ExternalReporting/ComprehensiveReport/ComprehensiveReport.vue'),
    props: true,
    meta: {
      title: 'Comprehensive Report',
      permissionCheck: null,
    },
  },
  {
    path: '/patient/:patientId/report/care-goals',
    name: '#patientCareGoalsReport',
    component: () =>
      import('@/pages/ExternalReporting/CareGoalsReport/CareGoalsReport.vue'),
    props: true,
    meta: {
      title: 'Care Goals Report',
      permissionCheck: null,
    },
  },
  ...patientProfileTabbed,
]
